/* PAPPOS — componentes del tema (web components, sin frameworks) */
(() => {
  const routes = window.ppRoutes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change' };
  const cleanSize = (v) => (v ? String(v).replace(/\s*mx$/i, '') : v);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Cajón genérico: menú móvil, carrito. */
  class PPDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => { if (e.target.closest('[data-pp-close]')) this.close(); });
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.setAttribute('open', '');
      document.body.classList.add('pp-lock');
      const f = this.querySelector('[data-pp-autofocus], button, a, input');
      if (f) f.focus({ preventScroll: true });
    }
    close() {
      this.removeAttribute('open');
      document.body.classList.remove('pp-lock');
      if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
    }
  }
  customElements.define('pp-drawer', PPDrawer);

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-pp-open]');
    if (!t) return;
    const d = document.getElementById(t.dataset.ppOpen);
    if (d && d.open) { e.preventDefault(); d.open(t); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('pp-drawer[open]').forEach((d) => d.close());
    document.querySelectorAll('.pp-facets.is-open').forEach((f) => f.classList.remove('is-open'));
  });

  /** Carrito: agrega y cambia cantidades con Cart API + Section Rendering API. */
  const PPCart = {
    section: 'pp-cart-drawer',
    drawer() { return document.getElementById('pp-cart'); },
    async request(url, body) {
      body.sections = this.section;
      body.sections_url = window.location.pathname;
      const res = await fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito');
      return data;
    },
    render(data) {
      const html = data.sections && data.sections[this.section];
      const d = this.drawer();
      if (!html || !d) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.pp-drawer__panel');
      const panel = d.querySelector('.pp-drawer__panel');
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      const count = doc.querySelector('[data-pp-count]');
      const n = count ? parseInt(count.dataset.ppCount, 10) : null;
      if (n !== null) document.querySelectorAll('[data-pp-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
    },
    async add(id, quantity = 1) {
      const data = await this.request(routes.cart_add_url, { items: [{ id: Number(id), quantity }] });
      this.render(data);
      const d = this.drawer();
      if (d) d.open();
      return data;
    },
    async change(line, quantity) {
      const d = this.drawer();
      if (d) d.setAttribute('aria-busy', 'true');
      try { this.render(await this.request(routes.cart_change_url, { line: Number(line), quantity: Number(quantity) })); }
      finally { if (d) d.removeAttribute('aria-busy'); }
    }
  };
  window.PPCart = PPCart;

  function alertInDrawer(msg) {
    const box = document.querySelector('#pp-cart [data-pp-cart-error]');
    if (box) { box.textContent = msg; box.hidden = false; }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pp-line]');
    if (!b) return;
    e.preventDefault();
    PPCart.change(b.dataset.ppLine, b.dataset.ppQty).catch((err) => alertInDrawer(err.message));
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-pp-quick-add]');
    if (!f) return;
    e.preventDefault();
    PPCart.add(f.querySelector('[name=id]').value).catch((err) => alertInDrawer(err.message));
  });

  /** Formulario de producto: elige talla/color, valida, agrega al carrito. */
  class PPProductForm extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('script[data-pp-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.idInput = this.form.querySelector('[name=id]');
      this.buttons = document.querySelectorAll('[data-pp-buy="' + this.dataset.section + '"]');
      this.label = this.querySelector('[data-pp-size-label]');
      this.stock = this.querySelector('[data-pp-stock]');
      this.error = this.querySelector('[data-pp-error]');
      this.addEventListener('change', (e) => { if (e.target.matches('[data-pp-option]')) this.update(); });
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.update();
    }
    selected() {
      return [...this.querySelectorAll('[data-pp-option-group]')].map((g) => { const c = g.querySelector('[data-pp-option]:checked'); return c ? c.value : null; });
    }
    update() {
      const sel = this.selected();
      this.querySelectorAll('[data-pp-option-group]').forEach((g, gi) => {
        g.querySelectorAll('[data-pp-option]').forEach((input) => {
          const ok = this.variants.some((v) => v.available && v.options[gi] === input.value && v.options.every((o, oi) => oi === gi || sel[oi] === null || sel[oi] === o));
          input.disabled = !ok;
          if (!ok && input.checked) input.checked = false;
        });
      });
      const s = this.selected();
      const groups = this.querySelectorAll('[data-pp-option-group]').length;
      const complete = groups === 0 || s.every((x) => x !== null);
      const v = complete ? this.variants.find((x) => x.options.every((o, i) => groups === 0 || o === s[i])) : null;
      this.variant = v && v.available ? v : null;
      if (this.variant) this.idInput.value = this.variant.id; else if (groups > 0) this.idInput.value = '';
      if (!this.variant && groups === 0 && this.idInput.value) this.variant = { id: this.idInput.value };
      const sizeIdx = Number(this.dataset.sizeIndex);
      const sizeVal = sizeIdx >= 0 ? cleanSize(s[sizeIdx]) : null;
      if (this.label) {
        this.label.textContent = this.label.dataset.base + ': ' + (sizeVal || 'elige una');
        this.label.classList.remove('is-error');
      }
      if (this.stock) {
        const q = this.variant && this.variant.qty;
        const show = !!(this.variant && this.variant.tracked && q > 0 && q <= Number(this.dataset.lowStock || 3));
        this.stock.hidden = !show;
        if (show) this.stock.textContent = (q === 1 ? 'Queda 1 par' : 'Quedan ' + q + ' pares') + (sizeVal ? ' en talla ' + sizeVal : '');
      }
      this.buttons.forEach((b) => {
        b.setAttribute('aria-disabled', this.variant ? 'false' : 'true');
        b.textContent = this.variant ? b.dataset.textAdd : (sizeIdx >= 0 ? b.dataset.textChoose : b.dataset.textSoldout);
      });
      document.querySelectorAll('[data-pp-sticky-sub="' + this.dataset.section + '"]').forEach((el) => { el.textContent = sizeVal ? 'Talla ' + sizeVal : (el.dataset.base || ''); });
      if (this.variant && this.variant.options && this.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href); url.searchParams.set('variant', this.variant.id); history.replaceState({}, '', url);
      }
    }
    async submit(e) {
      e.preventDefault();
      if (this.error) this.error.hidden = true;
      if (!this.variant) {
        if (this.label) { this.label.textContent = 'Elige tu talla para continuar'; this.label.classList.add('is-error'); }
        const g = this.querySelector('#tallas') || this.querySelector('[data-pp-option-group]');
        if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.buttons.forEach((b) => b.classList.add('is-loading'));
      try { await PPCart.add(this.variant.id, 1); }
      catch (err) { if (this.error) { this.error.textContent = err.message; this.error.hidden = false; } }
      finally { this.buttons.forEach((b) => b.classList.remove('is-loading')); }
    }
  }
  customElements.define('pp-product-form', PPProductForm);

  /** Galería: miniaturas en escritorio; en móvil se desliza con el dedo y los puntos marcan la foto. */
  class PPGallery extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.pp-gal__item')];
      this.dots = [...this.querySelectorAll('[data-pp-gdot]')];
      this.list = this.querySelector('.pp-gal__list');
      this.querySelectorAll('[data-pp-thumb]').forEach((t) => t.addEventListener('click', () => this.show(Number(t.dataset.ppThumb))));
      this.dots.forEach((d) => d.addEventListener('click', () => {
        const i = Number(d.dataset.ppGdot);
        if (this.list) this.list.scrollTo({ left: i * this.list.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        this.mark(i);
      }));
      if (this.list && this.dots.length) this.list.addEventListener('scroll', () => {
        this.mark(Math.round(this.list.scrollLeft / (this.list.clientWidth || 1)));
      }, { passive: true });
    }
    mark(i) { this.dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i))); }
    show(i) {
      this.items.forEach((el, k) => el.classList.toggle('is-active', k === i));
      this.querySelectorAll('[data-pp-thumb]').forEach((t) => t.setAttribute('aria-current', String(Number(t.dataset.ppThumb) === i)));
      this.mark(i);
    }
  }
  customElements.define('pp-gallery', PPGallery);

  /** Aviso breve en pantalla (ej. "Liga copiada"). */
  function ppToast(msg) {
    let t = document.querySelector('.pp-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pp-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t.ppTimer);
    t.ppTimer = setTimeout(() => t.classList.remove('is-on'), 2600);
  }

  /** Compartir: menú nativo del celular (WhatsApp, Messenger…); en computadora copia la liga. */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-pp-share]');
    if (!b) return;
    e.preventDefault();
    const url = b.dataset.url || window.location.href.split('?')[0];
    const title = b.dataset.title || document.title;
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch (x) { /* el cliente canceló */ }
      return;
    }
    let ok = false;
    try { await navigator.clipboard.writeText(url); ok = true; } catch (x) {
      const ta = document.createElement('textarea');
      ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { ok = document.execCommand('copy'); } catch (y) { ok = false; }
      ta.remove();
    }
    ppToast(ok ? 'Liga copiada. Pégala donde quieras compartirla.' : url);
  });

  /** Filtros de colección: en escritorio se aplican al marcar; en móvil con el botón.
      Navega al "action" del formulario (la colección o el Catálogo cuando la colección trae filtros fijos). */
  class PPFacets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.panel = this.querySelector('.pp-facets');
      if (!this.form) return;
      const desk = window.matchMedia('(min-width: 990px)');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-pp-sort]') || (desk.matches && e.target.matches('input[type=checkbox]'))) this.submit();
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-pp-facets-open]')) { this.panel.classList.add('is-open'); document.body.classList.add('pp-lock'); }
        if (e.target.closest('[data-pp-facets-close]')) { this.panel.classList.remove('is-open'); document.body.classList.remove('pp-lock'); }
      });
    }
    submit() {
      const fd = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      const keep = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (keep) params.set('preview_theme_id', keep);
      const url = new URL(this.form.getAttribute('action') || window.location.pathname, window.location.origin);
      url.search = params.toString();
      window.location.href = url.toString();
    }
  }
  customElements.define('pp-facets', PPFacets);

  /** Scroll infinito con paginación real: carga la siguiente página al acercarse al final y actualiza ?page=N. */
  class PPInfinite extends HTMLElement {
    connectedCallback() {
      this.grid = document.querySelector('[data-pp-grid]');
      this.btn = this.querySelector('[data-pp-more]');
      if (!this.grid || !this.dataset.next) return;
      if (this.btn) this.btn.addEventListener('click', (e) => { e.preventDefault(); this.load(); });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) this.load(); }, { rootMargin: '0px 0px 900px 0px' });
        this.io.observe(this);
      }
    }
    async load() {
      if (this.loading || !this.dataset.next) return;
      this.loading = true;
      this.classList.add('is-loading');
      if (this.btn) this.btn.textContent = 'Cargando…';
      try {
        const next = new URL(this.dataset.next, window.location.origin);
        const page = next.searchParams.get('page');
        next.searchParams.set('section_id', this.dataset.section);
        const res = await fetch(next.toString());
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('[data-pp-grid] > *').forEach((card) => this.grid.appendChild(document.importNode(card, true)));
        const fresh = doc.querySelector('pp-infinite');
        this.dataset.next = fresh ? (fresh.dataset.next || '') : '';
        const shown = fresh && fresh.querySelector('[data-pp-shown]');
        const mine = this.querySelector('[data-pp-shown]');
        if (shown && mine) mine.textContent = shown.textContent;
        if (page) { const u = new URL(window.location.href); u.searchParams.set('page', page); history.replaceState(history.state, '', u); }
        syncFavs();
      } catch (e) {
        /* si falla, el botón sigue funcionando como liga normal a la siguiente página */
        if (this.btn) { window.location.href = this.btn.href; return; }
      } finally {
        this.loading = false;
        this.classList.remove('is-loading');
        if (this.btn) this.btn.textContent = 'Ver más productos';
      }
      if (!this.dataset.next) {
        if (this.io) this.io.disconnect();
        if (this.btn) this.btn.remove();
      } else if (this.btn) {
        this.btn.href = this.dataset.next;
      }
    }
  }
  customElements.define('pp-infinite', PPInfinite);

  /** Búsqueda predictiva: muestra coincidencias mientras se escribe (Predictive Search API). */
  const psUrl = routes.predictive_search_url || '/search/suggest';
  document.querySelectorAll('form[role=search]').forEach((form, idx) => {
    const input = form.querySelector('input[name=q]');
    if (!input) return;
    const box = document.createElement('div');
    box.className = 'pp-ps-box';
    box.id = 'pp-ps-' + idx;
    box.hidden = true;
    form.classList.add('pp-ps-host');
    form.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');
    let timer; let ctrl; let last = '';
    const open = () => { box.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    const run = async (q) => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const p = new URLSearchParams({
        q,
        'resources[type]': 'product,query,collection',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide',
        'resources[options][fields]': 'title,vendor,product_type,variants.title,variants.sku,tag',
        section_id: 'pp-predictive-search'
      });
      try {
        const res = await fetch(psUrl + '?' + p.toString(), { signal: ctrl.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const r = doc.querySelector('.pp-ps');
        if (!r || input.value.trim() !== q) return;
        last = q;
        box.innerHTML = r.outerHTML;
        open();
      } catch (e) { /* búsqueda cancelada o sin red: no se muestra nada */ }
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => run(q), 200);
    });
    input.addEventListener('focus', () => { if (last && input.value.trim() === last && box.innerHTML) open(); });
    const links = () => [...box.querySelectorAll('a')];
    form.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      const items = links();
      const i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
      else if (e.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  });

  /** Botón para regresar al inicio en el catálogo. */
  const toTop = document.querySelector('[data-pp-totop]');
  if (toTop) {
    const onScroll = () => toTop.classList.toggle('is-on', window.scrollY > 700);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    toTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }


  /** Favoritos sin app: se guardan en el navegador (localStorage 'pp-favs', lista de handles). */
  const FAV_KEY = 'pp-favs';
  const favs = {
    get() { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; } },
    set(list) { try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* modo privado: no se guarda */ } }
  };
  function syncFavs() {
    const list = favs.get();
    document.querySelectorAll('[data-pp-fav]').forEach((b) => {
      const on = list.includes(b.dataset.ppFav);
      b.setAttribute('aria-pressed', String(on));
      const name = (b.getAttribute('aria-label') || '').split(': ').slice(1).join(': ');
      b.setAttribute('aria-label', (on ? 'Quitar de favoritos' : 'Agregar a favoritos') + (name ? ': ' + name : ''));
    });
    document.querySelectorAll('[data-pp-fav-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
  }
  window.ppSyncFavs = syncFavs;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pp-fav]');
    if (!b) return;
    e.preventDefault();
    const h = b.dataset.ppFav;
    let list = favs.get();
    const on = list.includes(h);
    list = on ? list.filter((x) => x !== h) : [h].concat(list).slice(0, 60);
    favs.set(list);
    b.classList.remove('is-pop'); void b.offsetWidth; if (!on) b.classList.add('is-pop');
    syncFavs();
    const wl = b.closest('pp-wishlist');
    if (wl && on) { const w = b.closest('.pp-card-w'); if (w) w.remove(); wl.refreshStatus(); }
  });
  syncFavs();

  /** Página de favoritos: pide cada tarjeta a /products/{handle}?view=pp-card. */
  class PPWishlist extends HTMLElement {
    async connectedCallback() {
      this.grid = this.querySelector('[data-pp-wl-grid]');
      this.status = this.querySelector('[data-pp-wl-status]');
      this.empty = this.querySelector('[data-pp-wl-empty]');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const list = favs.get();
      if (!list.length) { this.refreshStatus(); return; }
      const htmls = await Promise.all(list.map((h) => fetch(root + 'products/' + encodeURIComponent(h) + '?view=pp-card').then((r) => (r.ok ? r.text() : '')).catch(() => '')));
      htmls.forEach((html) => {
        if (!html || html.indexOf('pp-card') === -1) return;
        const t = document.createElement('template');
        t.innerHTML = html.trim();
        const card = t.content.querySelector('.pp-card-w');
        if (card) this.grid.appendChild(card);
      });
      this.hiddenCount = list.length - this.grid.children.length;
      syncFavs();
      this.refreshStatus();
    }
    refreshStatus() {
      const n = this.grid ? this.grid.children.length : 0;
      if (this.empty) this.empty.hidden = n > 0;
      if (this.status) {
        let txt = n === 0 ? '' : (n === 1 ? '1 producto guardado' : n + ' productos guardados');
        if (this.hiddenCount > 0) txt += (txt ? ' · ' : '') + (this.hiddenCount === 1 ? '1 favorito está agotado por ahora' : this.hiddenCount + ' favoritos están agotados por ahora');
        this.status.textContent = txt;
        this.status.hidden = !txt;
      }
    }
  }
  customElements.define('pp-wishlist', PPWishlist);

  /** Carrusel principal: avance automático con pausa, flechas, puntos y deslizar. */
  class PPSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pp-track]');
      if (!this.track) return;
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-pp-dot]')];
      this.i = 0;
      if (this.slides.length < 2) return;
      this.playing = this.dataset.autoplay === 'true' && !reduceMotion;
      this.classList.toggle('is-paused', !this.playing);
      const pause = this.querySelector('[data-pp-pause]');
      const setPauseLabel = () => { if (pause) pause.setAttribute('aria-label', this.playing ? 'Pausar carrusel' : 'Reproducir carrusel'); };
      setPauseLabel();
      if (pause) pause.addEventListener('click', () => { this.playing = !this.playing; this.classList.toggle('is-paused', !this.playing); setPauseLabel(); });
      const prev = this.querySelector('[data-pp-prev]'); const next = this.querySelector('[data-pp-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.i - 1));
      if (next) next.addEventListener('click', () => this.go(this.i + 1));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.ppDot))));
      let t;
      this.track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => { const i = Math.round(this.track.scrollLeft / this.track.clientWidth); if (i !== this.i) { this.i = i; this.mark(); } }, 60);
      }, { passive: true });
      this.addEventListener('mouseenter', () => { this.hold = true; });
      this.addEventListener('mouseleave', () => { this.hold = false; });
      this.addEventListener('focusin', () => { this.hold = true; });
      this.addEventListener('focusout', () => { this.hold = false; });
      this.track.addEventListener('touchstart', () => { this.hold = true; }, { passive: true });
      this.track.addEventListener('touchend', () => { setTimeout(() => { this.hold = false; }, 4000); }, { passive: true });
      const ms = Math.max(3, Number(this.dataset.speed) || 6) * 1000;
      this.timer = setInterval(() => { if (this.playing && !this.hold && document.visibilityState === 'visible') this.go(this.i + 1); }, ms);
      document.addEventListener('shopify:block:select', (e) => { const k = this.slides.indexOf(e.target); if (k >= 0) { this.playing = false; this.go(k); } });
      this.mark();
    }
    disconnectedCallback() { clearInterval(this.timer); }
    go(n) {
      const len = this.slides.length;
      this.i = (n + len) % len;
      this.track.scrollTo({ left: this.i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.mark();
    }
    mark() {
      this.dots.forEach((d, k) => d.setAttribute('aria-current', String(k === this.i)));
      this.slides.forEach((s, k) => { if (k === this.i) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
    }
  }
  customElements.define('pp-slider', PPSlider);

  /** Inicio de sesión / registro: términos obligatorios y suscripción opcional a ofertas. */
  const login = document.querySelector('[data-pp-login]');
  if (login && typeof login.showModal === 'function') {
    const terms = login.querySelector('[data-pp-terms]');
    const mkt = login.querySelector('[data-pp-mkt]');
    const mktBox = login.querySelector('[data-pp-mkt-box]');
    const mktEmail = login.querySelector('[data-pp-mkt-email]');
    const err = login.querySelector('[data-pp-login-err]');
    const gos = login.querySelectorAll('[data-pp-login-go]');
    const showErr = (msg) => { err.textContent = msg; err.hidden = !msg; };
    const refresh = () => { gos.forEach((a) => a.setAttribute('aria-disabled', terms.checked ? 'false' : 'true')); if (terms.checked) { terms.closest('.pp-check').classList.remove('is-error'); showErr(''); } };
    refresh();
    terms.addEventListener('change', refresh);
    mkt.addEventListener('change', () => { mktBox.hidden = !mkt.checked; if (mkt.checked) mktEmail.focus(); });
    document.addEventListener('click', (e) => {
      const o = e.target.closest('[data-pp-login-open]');
      if (!o) return;
      e.preventDefault();
      document.querySelectorAll('pp-drawer[open]').forEach((d) => d.close());
      login.showModal();
    });
    login.addEventListener('click', (e) => { if (e.target === login || e.target.closest('[data-pp-login-close]')) login.close(); });
    gos.forEach((a) => a.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!terms.checked) {
        terms.closest('.pp-check').classList.add('is-error');
        showErr('Para continuar acepta el Aviso de privacidad y los términos.');
        terms.focus();
        return;
      }
      if (mkt.checked) {
        const email = (mktEmail.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { showErr('Escribe un correo válido para recibir ofertas.'); mktEmail.focus(); return; }
        const form = document.getElementById('pp-login-mkt');
        if (form) {
          form.querySelector('[data-pp-mkt-field]').value = email;
          try {
            const res = await fetch(form.action, { method: 'POST', body: new FormData(form) });
            if (res.redirected && /challenge/.test(res.url)) { form.submit(); return; }
          } catch (x) { /* si falla la suscripción, igual seguimos al inicio de sesión */ }
        }
      }
      window.location.href = a.href;
    }));
  }

  /** Recomendaciones de producto (Product Recommendations API). */
  class PPRecs extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      const io = new IntersectionObserver(async (entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        try {
          const res = await fetch(this.dataset.url);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const fresh = doc.querySelector('pp-recs');
          if (fresh && fresh.querySelector('.pp-card')) { this.innerHTML = fresh.innerHTML; syncFavs(); } else this.hidden = true;
        } catch (e) { this.hidden = true; }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  customElements.define('pp-recs', PPRecs);
})();
